module.exports = __webpack_public_path__ + "img/orderHigh.74bd378f.svg";